import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";

// De lettertypen staan in de app zelf en worden niet bij Google opgehaald: anders ziet de
// app er zonder internet anders uit dan mét, en weet Google wanneer je je notities opent.
// Fraunces alleen met de gewichts-as (36 kB in plaats van 67 kB), en van IBM Plex alleen de
// drie gewichten die we gebruiken. Beide lettertypen staan onder de OFL-licentie.
import "@fontsource-variable/fraunces/wght.css";
import "@fontsource/ibm-plex-sans/latin-400.css";
import "@fontsource/ibm-plex-sans/latin-500.css";
import "@fontsource/ibm-plex-sans/latin-600.css";
import "@fontsource/ibm-plex-mono/latin-400.css";
import { App } from "./App.tsx";
import { volgHetNetwerk, verwerkWachtrij } from "./opslag.ts";
// De opmaak van KaTeX is klein (een paar tientallen kilobytes); de lettertypen haalt de
// browser pas op zodra er echt een formule op het scherm staat.
import "katex/dist/katex.min.css";
import "./stijl.css";

// De wachtrij mag nooit blijven staan omdat niemand eraan denkt: bij het openen, bij het
// terugkomen van offline, en bij het terugschakelen naar de app opnieuw proberen.
volgHetNetwerk();
void verwerkWachtrij();

registerSW({ immediate: true });

createRoot(document.getElementById("app")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
